import { useRequest } from '@Hooks/useRequest';
import { API } from '@Services';
import { LocalAuthorityWithFeature } from '@Types';
import { useCallback } from 'react';

export const useGetLocalAuthoritiesWithFeature = () => {
  const [fetch, response] = useRequest<LocalAuthorityWithFeature[]>();

  const getLocalAuthoritiesWithFeature = useCallback(
    (authorityIds: number[]) => {
      return fetch(API.paths.local_authorities_with_feature(authorityIds), 'get');
    },
    [fetch],
  );

  return [getLocalAuthoritiesWithFeature, response] as const;
};
